<!-- =========================================================================================
  File Name: Product.vue
  Description: Product product Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="mb-2" v-if="loaded">

      <div slot="no-body" class="tabs-container pl-6 py-3">
        <div class="w-full vx-row mb-2">
          <div class="vx-col w-3/12">
            <ejs-textbox floatLabelType="Auto" placeholder="ISBN" :enabled="editing" v-model="data_local.isbn"/>
          </div>
          <div class="flex vx-col w-9/12 items-center justify-end h-full">
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="save" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-save" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Guardar cambios</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm border border-solid border-warning cursor-pointer" @click="reset_data" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-corner-up-left" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Cancelar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="editing = true" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-edit-2" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Editar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-danger text-white cursor-pointer" @click="confirmDeleteRecord" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-x" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Eliminar</div>
            </div>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-full">
            <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :enabled="editing" v-model="data_local.name"/>
          </div>
        </div>
        <vs-tabs>
          <vs-tab label="Datos de venta">
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="Precio" format="N2" :enabled="editing" textAlign='Right' v-model="data_local.price" :min="0"/>
              </div>
              <div class="vx-col w-1/3">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Estado" highlight=true :dataSource="status" :fields="{text: 'value', value: 'id'}" v-model="data_local.status" :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="vx-col w-1/3 my-3">
                <ejs-checkbox label='Disponible en tienda en línea' v-model="data_local.available" :checked="data_local.available" :disabled="!editing"></ejs-checkbox>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-2/3">
                <ejs-multiselect ref="categories" floatLabelType="Auto" placeholder="Incluir en categorías" :dataSource="categories" mode="Box" :fields="{text: 'displayName', value: 'id'}" v-model="data_local.categoryList" :enabled="editing"></ejs-multiselect>
              </div>
              <div class="vx-col w-1/3">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Versión" highlight=true :dataSource="versions" :fields="{text: 'name', value: 'id'}" v-model="data_local.versionId" :enabled="editing"></ejs-dropdownlist>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-full">
                <ejs-multiselect ref="variations" floatLabelType="Auto" placeholder="Productos relacionados" :dataSource="products" mode="Box" :fields="{text: 'displayName', value: 'id'}" v-model="data_local.variationsList" :enabled="editing"></ejs-multiselect>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/3 my-3">
                <ejs-checkbox label='Producto en promoción' v-model="data_local.onSale" :checked="data_local.onSale" :disabled="!editing"></ejs-checkbox>
              </div>
              <div class="vx-col w-1/3" v-show="data_local.onSale">
                <ejs-numerictextbox floatLabelType="Auto" placeholder="Precio promoción" format="N2" :enabled="editing" textAlign='Right' v-model="data_local.salePrice" :min="0"/>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Características">
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Tipo de letra" highlight=true :dataSource="fontSizes" :fields="{text: 'name', value: 'id'}" v-model="data_local.fontSizeId" :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Tapa" :enabled="editing" v-model="data_local.cover"/>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Color" :enabled="editing" v-model="data_local.color"/>
              </div>
              <div class="vx-col w-1/3">
                <ejs-textbox floatLabelType="Auto" placeholder="Concordancia" :enabled="editing" v-model="data_local.concordance"/>
              </div>
            </div>
            <div class="w-full vx-row">
              <div class="vx-col w-full">
                <ejs-textbox floatLabelType="Auto" placeholder="URL de video" :enabled="editing" v-model="data_local.videoURL"/>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Descripción">
            <div class="w-full vx-row">
<!--              <div class="vx-col w-full">-->
<!--                <ejs-textbox name="description" :multiline="true" floatLabelType="Auto" placeholder="Descripción completa del producto" v-model="data_local.description" :enabled="editing"/>-->
<!--              </div>-->
              <div class="vx-col w-full">
                <ejs-richtexteditor ref="description" :height="400" :readonly="!editing" placeholder="Especifique una descripción amplia del producto" v-model="data_local.description"></ejs-richtexteditor>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Imágenes">

            <div class="w-full flex flex-row flex-wrap justify-start items-center mt-4 p-2">
              <div
                class="flex flex-col w-1/4 my-4 block bg-contain bg-no-repeat bg-center items-end justify-between border border-dotted border-primary"
                :style="{ 'background-image': `url(${previewImage})`}"
                style="height: 400px; background-repeat: no-repeat; background-position: center center;"
              >
                <div class="w-full p-2">
                  <h4 class="w-full">Imagen principal</h4>
                </div>
                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  @input="pickFile(null)"
                  class="opacity-0 absolute"
                />
                <div class="flex w-full items-end justify-between">
                  <vs-button class="ml-2 mb-2" color="success" icon-pack="feather" icon="icon-image" @click="selectImage(null)" v-if="editing">Seleccionar</vs-button>
                  <vs-button class="mr-2 mb-2" color="danger" icon-pack="feather" icon="icon-x" @click="previewImage = null" v-if="editing">Eliminar</vs-button>
                </div>
              </div>
              <div v-for="image in extraImages" :key="image.id"
                   class="flex flex-col w-1/4 my-4 ml-1 block bg-contain bg-no-repeat bg-center items-end justify-between border border-dotted border-primary"
                   :style="{ 'background-image': `url(${image.preview})`}"
                   style="height: 400px; background-repeat: no-repeat; background-position: center center;"
              >
                <div class="w-full p-2">
                  <h4 class="w-full">{{ image.id }}</h4>
                </div>
                <input
                  :ref="`fileInput_${image.id}`"
                  type="file"
                  accept="image/*"
                  @input="pickFile(image)"
                  class="opacity-0 absolute"
                />
                <div class="flex w-full items-end justify-between">
                  <vs-button class="ml-2 mb-2" color="success" icon-pack="feather" icon="icon-image" @click="selectImage(image)" v-if="editing">Seleccionar</vs-button>
                  <vs-button class="mr-2 mb-2" color="danger" icon-pack="feather" icon="icon-x" @click="image.preview = null" v-if="editing">Eliminar</vs-button>
                </div>
              </div>
              <div class="flex items-center justify-start p-8" v-if="editing">
                <vs-button icon="library_add" color="success" radius size="large" @click="data_local.imageCount++"/>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>

    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
import {DropDownListPlugin, MultiSelectPlugin} from "@syncfusion/ej2-vue-dropdowns";
import {RichTextEditorPlugin, Toolbar, Count, HtmlEditor, QuickToolbar} from '@syncfusion/ej2-vue-richtexteditor';
import {firebase, db, storage} from '@/firebaseConfig';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(RichTextEditorPlugin);

export default {
  data() {
    return {
      loaded: false,
      activeTab: 0,
      editing: false,
      id: 0,
      data: null,
      status: [{id: 'ACT', value: 'Activo'}, {id: 'IN', value: 'Inactivo'}],
      imageChanged: false,
      data_local: {
        id: 0,
        isbn: '',
        name: '',
        description: '',
        categoryId: '',
        versionId: '',
        categoryList: [],
        variationsList: [],
        price: 0.0,
        availableInPOS: true,
        combo: false,
        comments: '',
        status: '',
        onSale: false,
        salePrice: 0,
        stock: 0,
        cover: '',
        concordance: '',
        fontSizeId: '',
        videoURL: '',
        imageCount: 0
      },
      id_not_found: false,
      currentStatus: 0,
      uploadFieldName: 'photos',
      previewImage: null,
      extraImages: []
    }
  },
  provide: {
    richtexteditor:[Toolbar, Count, HtmlEditor, QuickToolbar]
  },
  computed: {
    imagesURL() {
      return this.$store.getters['getParameter']('images').baseURL;
    },
    categories() {
      return this.$store.getters.categoriesList;
    },
    products() {
      return this.$store.getters.productsList;
    },
    versions() {
      return this.$store.getters.versionsList;
    },
    fontSizes() {
      return this.$store.getters.fontSizesList;
    },
    image() {
      const imageURL = [this.imagesURL, '/products%2F', this.$data.data.id, '.png?alt=media'].join('');
      return imageURL;
    }
/*
    extraImages() {
      const list = [];
      if (this.data_local.imageCount > 0) {
        let letter = '';
        for (let i = 0; i < this.data_local.imageCount; i++) {
          letter = String.fromCharCode(i + 97);
          list.push({
            id: letter,
            imageName: `${this.data_local.id}${letter}.png`,
            preview: [this.imagesURL, '/products%2F', this.data_local.id, letter, '.png?alt=media'].join('')
          })
        }
      }
      return list;
    }
*/
  },
  methods: {
    reset_data() {
      if (this.id > 0) {
        if (this.$refs.images) {
          console.log(this.$refs.images);
        }
        this.imageChanged = false;
        this.data_local = {...this.data_local, ...JSON.parse(JSON.stringify(this.data))};
        this.data_local.categoryId = this.data.categoryId.toString();
        this.data_local.versionId = this.data.versionId.toString();
        this.data_local.categoryList = this.data.categories.split(',');
        this.data_local.variationsList = this.data.variations.split(',');
        if (!this.data_local.hasOwnProperty('imageCount')) {
          this.data_local.imageCount = 0;
        }
        this.extraImages = [];
        if (this.data_local.imageCount > 0) {
          let letter = '';
          for (let i = 0; i < this.data_local.imageCount; i++) {
            letter = String.fromCharCode(i + 97);
            this.extraImages.push({
              id: letter,
              imageName: `${this.data_local.id}${letter}.png`,
              preview: [this.imagesURL, '/products%2F', this.data_local.id, letter, '.png?alt=media'].join('')
            })
          }
        }
        this.previewImage = this.image;
        this.editing = false;
        this.loaded = true;
      } else {
        this.$router.push({name: 'products'});
      }
    },
    selectImage(image) {
      if (image == null) {
        this.$refs.fileInput.click();
      } else {
        const fileInput = this.$refs[`fileInput_${image.id}`];
        fileInput.click()
      }
    },
    pickFile(image) {
      if (image == null) {
        const input = this.$refs.fileInput;
        const file = input.files;
        if (file && file[0]) {
          const reader = new FileReader;
          reader.onload = e => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(file[0]);
          this.$emit('input', file[0]);
        }
      } else {
        const input = this.$refs.fileInput;
        const file = input.files;
        if (file && file[0]) {
          const reader = new FileReader;
          reader.onload = e => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(file[0]);
          this.$emit('input', file[0]);
        }
      }
    },
    getData(id) {
      if (id) {
        if (id == 0) {
          this.$vs.loading.close();
          this.loaded = true;
          this.id_not_found = false;
          this.editing = true;
        } else if (this.$store.products) {
          this.data = {...this.data_local, ...this.$store.getters.getProduct(id)};
          this.reset_data();
        } else {
          const self = this;
          setTimeout(function () {
            self.data = {...self.data_local, ...self.$store.getters.getProduct(id)};
            self.reset_data();
          }, 750);
        }
      } else {
        this.$vs.loading.close();
        this.loaded = true;
        if (id == 0) {
          this.id_not_found = false;
        }
        this.editing = true;
      }
    },
    validateForm() {
      let message = '';
      if (this.data_local.isbn.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe indicar un código`;
        // message += (message == '' ? '' : '<br/>') + 'Debe indicar un código';
      }
      if (this.data_local.name.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe indicar una descripción`;
      }
      if (this.data_local.versionId.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe seleccionar una versión`;
      }
      if (this.data_local.categoryList.length == 0) {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe seleccionar por lo menos un elemento en categorías incluídas`
      }
      if (this.data_local.status.trim() == '') {
        message = `${message}${(message == '' ? '' : '<br/>')}Debe seleccionar una estado`
      }
      if (message != '') {
        this.$vs.notify({
          title: 'Error validando información',
          text: message,
          color: 'danger'
        });
      }
      return (message == '');
    },
    updateImage(imageFile, newId) {
      const self = this;
      const fileParts = imageFile.name.split('.');
      let extension = '.';
      if (fileParts.length > 1) {
        extension = `.${fileParts[1]}`;
      }
      const imageRef = storage.ref().child(`products/${newId}${extension}`);
      imageRef.put(imageFile)
        .then(() => {
          self.$vs.notify({
            title: 'Información actualizada',
            text: 'Datos del producto fueron actualizados correctamente',
            color: 'primary'
          });
          if (self.id == 0) {
            self.$router.push({name: 'product', params: {id: newId}});
          }
          self.editing = false;
        })
        .catch((error) => {
          self.$vs.notify({
            title: 'ADVERTENCIA',
            text: `Datos del producto fueron actualizados correctamente pero ocurrió un error al actualizar imagen: ${error.message}`,
            color: 'warning'
          });
        });
      self.$vs.loading.close();
    },
    updateList(list, newId) {
      const self = this;
      db.collection('catalogs').doc('products').update({list: list})
        .then(() => {
          if (self.$refs.fileInput && self.$refs.fileInput.files && self.$refs.fileInput.files.length > 0) {
            self.updateImage(self.$refs.fileInput.files[0], newId);
          } else {
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Datos del producto fueron actualizados correctamente',
              color: 'primary'
            });
            if (self.id == 0) {
              self.$router.push({name: 'product', params: {id: newId}});
            }
            self.editing = false;
            self.$vs.loading.close();
          }
        })
        .catch((error) => {
          self.$vs.notify({
            title: 'Error al actualizar',
            text: error.message,
            color: 'danger'
          });
          self.$vs.loading.close();
        })
    },
    save() {
      if (this.validateForm()) {
        this.$vs.loading({
          text: 'Guardando información de producto',
          type: 'point'
        });
        if (typeof this.$refs.description == 'string') {
          this.data_local.description = this.$refs.description;
        }
        this.data_local.searchField = `${this.data_local.isbn} | ${this.data_local.name}`;
        this.data_local.statusName = this.data_local.status == 'ACT' ? 'Activo' : 'Inactivo';
        const list = [...this.$store.getters.productsList];
        if (this.data_local.id > 0) {
          const index = list.findIndex(i => i.id === this.data_local.id);
          if (index >= 0) {
            const categories = this.data_local.categoryList.join(',');
            const variations = this.data_local.variationsList.join(',');
            list[index] = JSON.parse(JSON.stringify(this.data_local));
            list[index].categories = categories;
            list[index].variations = variations;
            delete list[index].categoryList;
            delete list[index].variationsList;
            this.updateList(list, this.data_local.id);
          }
        } else {
          const self = this;
          db.collection('catalogs').doc('products').update({sequence: firebase.firestore.FieldValue.increment(1)})
            .then(() => {
              const data = {...self.data_local};
              db.collection('catalogs').doc('products').get()
                .then(doc => {
                  if (doc.exists) {
                    const newId = doc.data();
                    data.id = newId.sequence;
                    data.categories = data.categoryList.join(',');
                    data.variations = data.variationsList.join(',');
                    delete data.categoryList;
                    delete data.variationsList;
                    list.push(data);
                    self.updateList(list, data.id);
                  }
                })
            });
        }
      }
    },
    confirmDeleteRecord() {
      console.log('Delete');
    }
  },

  mounted() {
    this.id = parseInt(this.$route.params.id);
    const self = this;
    setTimeout(function () {
      self.getData(self.id);
    }, 750);
  }
}
</script>

<style lang="scss">
@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
/*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-lists/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
/*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
@import "../../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
</style>
